import { gql } from '@apollo/client';

export const FACILITIES = gql`
    query universalFacilitySearch {
        system {
            companies {
                id
                name
                alias
                facilities {
                    id
                    name
                    alias
                }
            }
        }
    }
`;
